import { Space, Table, Typography } from 'antd'

import CoreBadge from 'components/badge/Badge'
import ServiceStatusBadge from 'components/connectors/ServiceStatusBadge'
import { UnderlinedLink } from 'components/link/Link'
import { Links } from 'components/routes/paths'

import { Tenant, TenantRef } from 'models/tenant'

import { renderFormatMessage } from 'helpers/intl'
import { buildRailsListingUrlWithId } from 'helpers/url'
import { useTenantTranslation } from 'hooks/translation/useTenantTranslation'
import { useSelector } from 'hooks/useSelector'
import { useAppState } from 'state'
import TenantsActionsMenu from '../TenantsActionsMenu'

export const TenantsColumns = () => {
  const { tenantsTableNameHeading, tenantsTableChargerCountHeading } = useTenantTranslation()
  const { currentUser } = useAppState()
  const { siteLabelCleaner } = useSelector()
  const columns = [
    {
      title: tenantsTableNameHeading,
      key: 'tenantName',
      render: (t: TenantRef) => (
        <UnderlinedLink to={Links.tenant({ tenantId: `${t.id}` })}>
          <Typography.Text
            className="hover-underline"
            ellipsis={{ tooltip: siteLabelCleaner(t.combineName || t.displayName || t.name || '-') }}
          >
            {siteLabelCleaner(t.combineName || t.displayName || t.name || '-')}
          </Typography.Text>
        </UnderlinedLink>
      ),
      width: '20%',
    },
    {
      title: renderFormatMessage('dashboard.tenantPage.tenantTabOverview.accountName', 'Account Name'),
      key: 'masterAccount',
      render: (t: Tenant) => t.masterAccount?.name,
      width: '15%',
    },
    ...(currentUser?.role === 'admin'
      ? [
          {
            title: renderFormatMessage('dashboard.tenantPage.tenantTabOverview.tenantStatus', 'Site Status'),
            key: 'tenantStatus',
            render: (t: TenantRef) => (t.status ? <ServiceStatusBadge state={t.status} /> : null),
            width: '160px', //Width that fits Direct Deposit Information status (longest status name)
          },
        ]
      : []),
    {
      title: tenantsTableChargerCountHeading,
      dataIndex: 'chargerCount',
      sorter: (a: TenantRef, b: TenantRef) => {
        const av = a.chargerCount ? a.chargerCount : 0
        const bv = b.chargerCount ? b.chargerCount : 0
        return av - bv
      },
      width: '160px',
    },
    {
      title: renderFormatMessage('dashboard.charger.chargerIds', 'Charger ID (s)'),
      key: 'listingTitles',
      render: (tenant: Tenant) => (
        <Space wrap>
          {tenant.listingTitles?.map((listing) => (
            <CoreBadge
              key={listing.id}
              title={listing.title}
              href={
                currentUser?.role !== 'admin'
                  ? buildRailsListingUrlWithId(listing.id, listing.title)
                  : Links.listing({ listingId: listing.id })
              }
            />
          ))}
        </Space>
      ),
    },
    Table.EXPAND_COLUMN,
    ...(currentUser?.role !== 'admin'
      ? [
          {
            title: 'Actions',
            key: 'actions',
            align: 'right',
            render: (tenant: Tenant) => <TenantsActionsMenu tenant={tenant} />,
            width: '160px',
          },
        ]
      : []),
  ]
  return columns
}
